const ListViews = Object.freeze({
  'all': 'All',
  'featured': 'Featured',
});

const Media = Object.freeze({
  'Article': 'Article',
  'Sounds': 'Sounds',
  'RelaxRest': 'Relax & Rest',
  'Stories': 'Stories',
  'Mix': 'Mix',
});

export const getQuestionModalTitleForSorting = (view, key) => {
  return `Do you want to update ${ListViews[view]} ${Media[key]} list?`;
};

export const sortingUpdatedSuccessfullyMsg = (view, key) => {
  return `${ListViews[view]} ${Media[key]} List Updated Successfully`;
};